import { type CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

const white = ui.white[500];
const black = ui.black[500];
const neutral500 = ui.neutral[500];

export const tabsContainerStyle: CSSObject = {
  width: "100%",
  maxWidth: "1280px",
  alignSelf: "center",
  marginBottom: "24px",
  textAlign: "center",
};

export const tabListStyle: CSSObject = {
  width: "fit-content",
  margin: "0 auto",
  backgroundColor: white,
  borderRadius: "24px 24px 0 0",

  "&&": {
    padding: "8px",
    justifyItems: "center",
    justifySelf: "center",
  },

  ":after": {
    display: "none",
  },

  "&&&&&&&&&& li, &&&& button": {
    borderRadius: "24px",
    fontWeight: 700,
    color: neutral500,
    height: "40px",
  },

  "&&&& button": {
    padding: "8px 12px 8px 24px",
  },

  "&&&&& button[aria-selected='true']": {
    backgroundColor: black,
    color: white,
  },
};

export const tabPanelsStyle: CSSObject = {
  "&&&": { borderRadius: "24px" },
  textAlign: "left",
};
